import { useTranslation } from "@redotech/redo-i18n";

import { ReturnWarning } from "@redotech/redo-model/return";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";

export function WarningsCard({ warnings }: { warnings: ReturnWarning[] }) {
  const { t } = useTranslation();
  return (
    <Flex flexDirection="column">
      <Text>{t("There were some problems with your return.")}</Text>
      <Text>{t("Here are the issues we are working to resolve:")}</Text>
      {warnings.map((warning: ReturnWarning, i) => {
        return (
          <Flex flexDirection="column" key={i}>
            <Text> {warning.customerMessage}</Text>
          </Flex>
        );
      })}
    </Flex>
  );
}
